<template>
  <div
    v-if="sectionInfo && isVisible"
    v-on-display="{ sectionInfo, context: this }"
    class="multi autoplay-band"
  >
    <div class="title">
      <h1 v-band-title class="title-area" tabindex="0">
        <span class="label">{{ multiSectionTitle }}</span>
      </h1>
    </div>
    <lazy-component @show="() => setData()">
      <swiper :options="swiperOptions">
        <swiper-slide
          v-for="(cell, index) in cellList"
          :key="`${index}__${cell?.alt ?? ''}`"
          class="swiper swiper-container-horizontal"
        >
          <ComingSoonPlayerCell
            :cell-info="cell"
            :thumbnail-info="thumbnailInfo"
          />
        </swiper-slide>
        <div slot="button-prev" class="swiper-button-prev"></div>
        <div slot="button-next" class="swiper-button-next"></div>
      </swiper>
    </lazy-component>
    <a
      v-if="hasViewMore"
      href="#"
      class="btn-more all"
      @click.prevent="viewMore(sectionInfo)"
      >{{ viewMoreTitle(sectionInfo, '더보기') }}</a
    >
  </div>
</template>
<script>
  import { ref } from 'vue'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import MultiSectionMixin from '@/mixins/multisection.mixin'
  import { bandTitle, onDisplay } from '@/common/resources/directives'
  import { convertBand } from '@/common/converter/convert-band'
  import {
    COMMON_SWIPER_OPTIONS,
    SLIDES_PER_GROUP,
  } from '@/common/resources/swiper.const'
  import ComingSoonPlayerCell from '@/components/model/cell/instant-player/ComingSoonPlayerCell.vue'
  import { previewCell } from '@/common/utils/like-status/preview-cell'

  export default {
    components: {
      ComingSoonPlayerCell,
      swiper,
      swiperSlide,
    },
    directives: {
      bandTitle,
      onDisplay,
    },
    mixins: [MultiSectionMixin],
    props: {
      catalogInfo: {
        type: Object,
        default: () => {},
      },
      sectionInfo: {
        type: Object,
        default: () => {},
      },
      thumbnailInfo: {
        type: Object,
        default: () => {},
      },
    },
    setup(props) {
      const swiperOptions = ref({
        height: props.thumbnailInfo.height,
        spaceBetween: COMMON_SWIPER_OPTIONS.SPACE_BETWEEN,
        slidesPerView: COMMON_SWIPER_OPTIONS.SLIDES_PER_VIEW,
        slidesPerGroup: SLIDES_PER_GROUP.HORIZONTAL_L,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        observer: true,
      })
      const cellList = ref([])
      const band = ref({})
      const isVisible = ref(true)

      const setData = async () => {
        try {
          band.value = await convertBand(props.catalogInfo)
          cellList.value = previewCell(band.value?.band?.celllist)
          isVisible.value = true
        } catch (e) {
          isVisible.value = false
        }
      }

      return {
        swiperOptions,
        cellList,
        band,
        isVisible,
        setData,
      }
    },
  }
</script>
<style lang="scss" src="@/assets/scss/category/new_band.scss"></style>
<style scoped lang="scss">
  .multi {
    width: auto;
    padding: 0;
    .swiper-slide {
      width: auto;
    }
    .title {
      padding: 0 100px;
    }
    .btn-more.all {
      right: 100px;
    }
    .swiper-button-prev,
    .swiper-button-next {
      left: 70px;
      opacity: 0;
    }
    .swiper-button-next {
      left: auto;
      right: 70px;
    }
    &:hover {
      .swiper-button-prev,
      .swiper-button-next {
        left: 100px;
        opacity: 1;
      }
      .swiper-button-next {
        left: auto;
        right: 100px;
      }
      .swiper-button-prev.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
      }
      .swiper-button-next.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
      }
    }
    .swiper-container {
      position: relative;
      padding: 0 100px;
      min-width: 1440px;
      &:before,
      &:after {
        position: absolute;
        left: 0;
        top: 0;
        width: 100px;
        height: 360px;
        background: linear-gradient(
          270deg,
          rgba(244, 245, 246, 0) 0%,
          #1b1b1b 100%
        );
        z-index: 10;
        content: '';
      }
      &:after {
        left: auto;
        right: 0;
        background: linear-gradient(
          90deg,
          rgba(244, 245, 246, 0) 0%,
          #1b1b1b 100%
        );
      }
    }
    &.autoplay-band {
      min-height: 421px;
    }
  }
</style>
